<template>
  <div class="account">
    <div class="account__content">
      <p>
        <routerLink to="/messaging">&#8592; back to messages</routerLink>
      </p>
      <div>
        <div>
          <div class="account__content--name">Subject:</div>
          <div class="account__content--input">
            <input type="text" />
          </div>
        </div>
        <div>
          <div class="account__content--name">Message:</div>
          <div class="account__content--textarea">
            <textarea></textarea>
          </div>
        </div>
        <div>
          <div class="account__content--name">Attach File(s):</div>
          <div class="account__content--upload">
            <div v-show="!uploadedFile">
              <img src="./../../../assets/images/upload.svg" alt />
            </div>
            <p v-show="!uploadedFile">upload</p>
            <p v-show="uploadedFile">{{uploadedFileName}}</p>
            <input type="file" ref="message" @change="attachFile" />
          </div>
        </div>
        <div>
          <div class="account__content--btn">Send Message</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewMessage",
  data() {
    return {
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      previewImage: ""
    };
  },
  methods: {
    attachFile() {
      this.fileName = this.$refs.message;
      this.file = this.$refs.message.files[0];
      // const ext = this.fileName.value.split(".").pop();

      if (this.file) {
        this.uploadedFile = true;
        this.uploadedFileName = this.fileName.value.split("\\").pop();
        // this.previewImage = URL.createObjectURL(this.file);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.account {
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(217, 217, 217, 0.98);
  background-color: #ffffff;
  padding: 20px;

  > .account__content {
    > p {
      font-size: 0.729vw;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.21;
      letter-spacing: normal;
      text-align: left;
      color: #caced5;

      > a {
        text-decoration: none;
        color: #caced5;
      }
    }

    > div {
      margin-top: 50px;
      > div {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: flex-start;
        align-content: center;
        margin-bottom: 40px;

        > .account__content--name {
          width: 150px;
        }

        > .account__content--input {
          width: calc(100% - 150px);
          height: 40px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          overflow: hidden;

          > input {
            height: 40px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
            padding: 0 5px;
          }
        }

        > .account__content--textarea {
          width: calc(100% - 150px);
          height: 200px;
          border: solid 1px #c7c7c7;
          background-color: #ffffff;
          overflow: hidden;

          > textarea {
            height: 200px;
            border: solid 1px #c7c7c7;
            background-color: #ffffff;
            border: 0;
            outline: 0;
            padding: 10px 5px;
            resize: none;
          }
        }

        > .account__content--upload {
          width: 150px;
          height: 100px;
          border: dotted 1px #5099de;
          background-color: #ffffff;
          overflow: hidden;
          position: relative;

          > input {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
          }

          > div {
            width: 20px;
            margin: 20px auto 0 auto;
          }

          > p {
            font-size: 0.938vw;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
            margin-top: 10px;
          }
        }

        > .account__content--btn {
          width: 12.135vw;
          height: 40px;
          border-radius: 5px;
          background-color: #5099de;
          font-size: 0.938vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.22;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
        }
      }
    }
  }
}
</style>